import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as sharedActions } from "@shared/store";
import { selectors as hospitalSelectors } from "@containers/Hospital/store";
import { actions } from "@containers/SensorDataRestoringRequest/store";
import { CreateSensorDataRestoringRequestRequest } from "@containers/SensorDataRestoringRequest/interfaces";
import { SensorDataRestoringRequestForm } from "@containers/SensorDataRestoringRequest/components";

import "./index.scss";

interface SensorDataRestoringRequestCreateContainerProps {
  onClose: () => void;
}

const SensorDataRestoringRequestCreateContainer = (props: SensorDataRestoringRequestCreateContainerProps) => {
  const { onClose } = props;

  const dispatch = useDispatch();

  const hospital = useSelector(hospitalSelectors.getHospital());

  const createSensorDataRestoringRequest = useCallback(
    (data: CreateSensorDataRestoringRequestRequest) => {
      dispatch(
        actions.createSensorDataRestoringRequest.request({
          cb: () => dispatch(sharedActions.hideOverlay()),
          ...data,
        }),
      );
    },
    [dispatch],
  );

  const changeFormValues = useCallback(() => {
    dispatch(sharedActions.updateOverlay({ leaveConfirm: true }));
  }, [dispatch]);

  return (
    <div className="sensor-data-session-container">
      {hospital ? (
        <SensorDataRestoringRequestForm
          onSubmitForm={createSensorDataRestoringRequest}
          onChangeForm={changeFormValues}
          onCloseForm={onClose}
          hospital={hospital}
        />
      ) : null}
    </div>
  );
};

export default SensorDataRestoringRequestCreateContainer;
